.wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  justify-content: flex-start;
}

.title {
  color: var(--Text-TextPrimary, color(display-p3 0.1333 0.1176 0.102));
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif);
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  text-align: center;

  span {
    color: var(--ed-brand, #BA61FE);
  }
}

.img {
  width: 100%;
}

// Dark mode
:global body.dark {
  :local {
    .title {
      color: #FFFBF2;
    }
  }
}
